import {Component, OnInit} from '@angular/core';
import {AbstractGamePlayComponent} from "../abstract-game-play.component";
import {GamePlay} from "../../model/game-play";
import {DialogResumeGameComponent} from "../../components/dialog-resume-game/dialog-resume-game.component";
import {GameStatus} from "../../model/gameStatus";
import {Down} from "../../model/down";
import { TopSectionComponent } from '../../components/top-section/top-section.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-resume-game',
    templateUrl: './resume-game.component.html',
    styleUrls: ['./resume-game.component.scss'],
    imports: [TopSectionComponent, RouterLink, RouterLinkActive, TranslocoModule]
})
export class ResumeGameComponent extends AbstractGamePlayComponent implements OnInit{
  lastGamePlay?: GamePlay
  gamePlay!: GamePlay
  // Calculé une seule fois au chargement plutôt que dans le template : `isGameInOvertime()`
  // appelle `getFirstPendingGamePlay()`, qui peut créer et ajouter un GamePlay (écriture du
  // signal `_gamePlayList`). Invoqué depuis un `@if` du template, cette écriture se produit
  // pendant l'évaluation réactive du template et déclenche NG0600.
  isGameInOvertime = false

  ngOnInit(): void {
    this.gamePlay = this.game.getFirstPendingGamePlay();
    this.isGameInOvertime = this.game.isGameInOvertime();
    if ((this.gamePlay._status === GameStatus.Pending && this.gamePlay.distance === null) ||
      this.gamePlay.yardLine === 'TD' ||
      this.gamePlay.yardLine === 'SF' ||
      this.gamePlay.yardLine === 'SIMPLE' ||
      this.gamePlay.yardLine === '' ||
      this.gamePlay.down === Down.D0
    ) {
        this._bottomSheet.open(DialogResumeGameComponent, {
          panelClass: 'my-bottom-sheet-resume-game'
        });
    }
  }
}
